import { booleanAttribute, Directive, effect, inject, input } from '@angular/core';
import { UiButtonComponent } from '../ui-elements/ui-button/ui-button.component';
import { FormPageHeaderDirective } from './form-page-header.directive';

/** Shares header Back styling; navigation and labels remain owned by the page. */
@Directive({
  selector: 'app-ui-button[appHeaderBackButton]',
  standalone: false,
})
export class HeaderBackButtonDirective {
  // A false value keeps the same button in its secondary, icon-free Cancel state.
  readonly appHeaderBackButton = input(true, { transform: booleanAttribute });
  readonly headerBackMobileIcon = input('chevron_left');

  private readonly button = inject(UiButtonComponent, { self: true });
  private readonly header = inject(FormPageHeaderDirective, { optional: true });

  constructor() {
    effect(() => {
      const isBack = this.appHeaderBackButton();
      const isDesktop = this.header?.isDesktopLayout ?? false;
      const backIcon = isDesktop ? 'arrow_back' : this.headerBackMobileIcon();
      this.button.buttonType = isBack && isDesktop ? 'mat' : 'secondary';
      this.button.icon = isBack ? backIcon : '';
    });
  }
}
